import { createContext, useContext } from "react";
import { DEFAULT_CONTACT, type ContactInfo } from "@/lib/site-contact";

const ContactInfoContext = createContext<ContactInfo>(DEFAULT_CONTACT);

/**
 * Provee los datos de contacto públicos (cargados en SSR por el loader raíz)
 * a los componentes del sitio. Sin provider, retorna DEFAULT_CONTACT.
 */
export function ContactInfoProvider({
  value,
  children,
}: {
  value: ContactInfo;
  children: React.ReactNode;
}) {
  return <ContactInfoContext.Provider value={value}>{children}</ContactInfoContext.Provider>;
}

/** Devuelve siempre un ContactInfo válido (defaults si no hay provider). */
// eslint-disable-next-line react-refresh/only-export-components
export function useContactInfo(): ContactInfo {
  return useContext(ContactInfoContext);
}
